module.exports = __webpack_public_path__ + "images/b970b2f9acdf6c93d623d6f09004558a.svg";